import {
  Box,
  Divider,
  IconButton,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import useLanguage from "../../../hooks/useLanguage";
import {
  DrawerWrapper,
  LogoPreview,
  LogoPreviewWrapper,
  TitleWrapper,
} from "../style";
import { useEffect, useRef, useState } from "react";

const BodyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export default function MetadataDrawer({
  siteId,
  onClose,
  initValue,
  onChange,
}) {
  const [
    {
      pages: {
        configurations: { txtDrawer: text },
      },
    },
  ] = useLanguage();
  const [value, setValue] = useState(initValue);
  const [fileMetadata, setFileMetadata] = useState(null);
  const fileInputRef = useRef(null);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({ ...prev, [name]: value }));
    onChange(e);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    file.src = URL.createObjectURL(file);
    setValue((prev) => ({ ...prev, [fileMetadata]: file }));
    onChange(e);
  };

  const handleFileUploadClick = (e) => {
    const key = e.target.name;
    setFileMetadata(key);
    fileInputRef.current.click();
  };

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  return (
    <DrawerWrapper>
      <TitleWrapper>
        <Typography variant="h5">{text.title}</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </TitleWrapper>
      <Typography variant="body2">{text.description}</Typography>
      <Divider />
      <BodyWrapper>
        <Typography variant="h6">{text.media}</Typography>
        <LogoPreviewWrapper content={text.logo}>
          <LogoPreview
            name="logo"
            src={value.logo?.src || value.logo}
            onClick={handleFileUploadClick}
            type="file"
          />
        </LogoPreviewWrapper>
        <LogoPreviewWrapper content={text.favicon}>
          <LogoPreview
            name="favicon"
            src={value.favicon?.src || value.favicon}
            onClick={handleFileUploadClick}
            type="file"
          />
        </LogoPreviewWrapper>
      </BodyWrapper>
      <input
        ref={fileInputRef}
        type="file"
        name="logo"
        accept="image/*"
        onChange={handleImageUpload}
        style={{ display: "none" }}
      />
    </DrawerWrapper>
  );
}
